/**
 * Résout l'URL du backend à l'exécution selon le hostname du navigateur.
 *
 * Règle :
 *   localhost | *dev-front*  →  https://dev-api.envallabstock.online
 *   tout autre host           →  https://api.envallabstock.online
 *
 * Retourne l'URL de base SANS slash final ni /api (les clients l'ajoutent eux-mêmes).
 */
export function resolveApiUrl() {
  const DEV_API  = 'https://dev-api.envallabstock.online'
  const PROD_API = 'https://api.envallabstock.online'

  // Côté serveur (SSR / tests Node) → pas de window
  if (typeof window === 'undefined') return DEV_API

  const hostname = window.location.hostname

  if (hostname === 'localhost' || hostname.includes('dev-front')) {
    return DEV_API
  }

  return PROD_API
}
